<template>
  <b-card>
    <b-form @submit.prevent="fetch">
      <b-row>

        <b-col md="4">
          <b-form-group label="Minutes">
            <b-form-input
              v-model="filterData.minutes"
              type="number"
            />
          </b-form-group>
        </b-col>
        <b-col md="4">
          <b-form-group label="Minimum Demand">
            <b-form-input
              v-model="filterData.minimumDemand"
              type="number"
            />
          </b-form-group>
        </b-col>
        <b-col
          md="4"
          class="d-flex align-items-center"
        >
          <b-button
            :disabled="!filterData.minutes || !filterData.minimumDemand || fetching"
            variant="primary"
            block
            type="submit"
          >
            <b-spinner
              v-if="fetching"
              small
            />
            Search
          </b-button>
        </b-col>
        <b-col md="12">
          <div id="supply-demand-map" />
        </b-col>
      </b-row>
    </b-form>
  </b-card>
</template>

<script>
import { onMounted, ref } from '@vue/composition-api'
import {
  BCard, BFormGroup, BFormInput, BRow, BCol, BButton, BSpinner, BForm,
} from 'bootstrap-vue'
import axiosIns from '@/libs/axios'
import { errorNotification } from '@/utils/toast-notifications'

export default {
  components: {
    BCard,
    BFormGroup,
    BFormInput,
    BRow,
    BForm,
    BSpinner,
    BCol,
    BButton,
  },
  setup() {
    const filterData = ref({
      minutes: null,
      minimumDemand: null,
    })

    const map = ref(null)
    const polygons = ref([])
    const googlePolygons = ref([])

    const generagePolygons = () => {
    // eslint-disable-next-line no-undef
      const bounds = new google.maps.LatLngBounds()
      googlePolygons.value = polygons.value.map(polygon => {
        // eslint-disable-next-line no-undef
        const polyTemp = new google.maps.Polygon({
          paths: polygon.polygon.map(p => {
            bounds.extend(
              // eslint-disable-next-line no-undef
              new google.maps.LatLng(
                p[1],
                p[0],
              ),
            )
            return { lat: p[1], lng: p[0] }
          }),
          strokeColor: '#FF0000',
          strokeOpacity: 0.8,
          strokeWeight: 2,
          fillColor: '#FF0000',
          fillOpacity: 0.35,
        })
        const contentString = `<div style="display:flex;flex-direction:column">
            <h5>Doc Count: ${polygon.docCount}</h5>
            <h5>Supply: ${polygon.supply}</h5>
            <h5>Supply Ratio: ${polygon.supplyRatio}</h5>
        </div>`
        // eslint-disable-next-line no-undef
        const infowindow = new google.maps.InfoWindow()
        polyTemp.setMap(map.value)
        // eslint-disable-next-line no-undef
        google.maps.event.addListener(polyTemp, 'click', event => {
          infowindow.setContent(contentString)
          infowindow.setPosition(event.latLng)
          infowindow.open(map.value)
        })
        return polyTemp
      })
      map.value.fitBounds(bounds)
    }

    const fetching = ref(false)

    const fetch = async () => {
      fetching.value = true
      try {
        googlePolygons.value.forEach(poly => {
          poly.setMap(null)
        })
        const result = await axiosIns.get('/zones/heatmap', {
          params: {
            minutes: filterData.value.minutes,
            minimumDemand: filterData.value.minimumDemand,
          },
        })
        const { cells } = result.data.data

        polygons.value = cells.map(cell => ({
          docCount: cell.doc_count,
          supply: cell.supply,
          supplyRatio: cell.supply_ratio,
          // eslint-disable-next-line no-underscore-dangle
          polygon: cell.cell_details.hits.hits[0]._source.polygon.coordinates[0],
        }))
        generagePolygons()
      } catch (error) {
        errorNotification('An error occured')
      } finally {
        fetching.value = false
      }
    }

    const initMap = () => {
    // eslint-disable-next-line no-undef
      map.value = new google.maps.Map(document.getElementById('supply-demand-map'), {
        zoom: 10,
        center: {
          lat: 31.963158, lng: 35.930359,
        },
      })
    }

    onMounted(() => {
      initMap()
    })

    return {
      fetch,
      fetching,
      filterData,
    }
  },
}
</script>

<style scoped>
#supply-demand-map {
  width: 100%;
  height: 400px;
}
</style>
